export default "__VITE_ASSET__6c0d4e7e__"